import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const toastContainer = () => {
	return (
		<ToastContainer
			position="bottom-center"
			autoClose={800}
			hideProgressBar={false}
			newestOnTop={true}
			closeOnClick={true}
			rtl={false}
			pauseOnFocusLoss={false}
			draggable
			pauseOnHover
			theme="colored"
		/>
	);
};

export const compressImage = (file, quality) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = (event) => {
			const img = new Image();
			img.src = event.target.result;
			img.onload = () => {
				let width = img.width;
				let height = img.height;
				const maxSize = 500;

				if (width > height) {
					if (width > maxSize) {
						height = (height * maxSize) / width;
						width = maxSize;
					}
				} else {
					if (height > maxSize) {
						width = (width * maxSize) / height;
						height = maxSize;
					}
				}

				const canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;
				const ctx = canvas.getContext('2d');

				ctx.drawImage(img, 0, 0, width, height);

				canvas.toBlob(
					(blob) => {
						if (blob) {
							resolve(new File([blob], file.name, { type: file.type }));
						} else {
							reject(new Error("Compression failed."));
						}
					},
					file.type,
					quality
				);
			};
		};

		reader.onerror = (error) => reject(error);
	});
};

export const phoneScreenList = Object.freeze([
  { label: "Booking Check-in", value: "BookingCheckInScreen" },
  { label: "Booking Check-out", value: "BookingCheckoutScreen" },
  { label: "Booking Details", value: "BookingDetailsScreen" },
  { label: "Change Address", value: "ChangeAddressScreen" },
  { label: "Charger Details", value: "ChargerDetailsScreen" },
  { label: "Charging Completed", value: "ChargingCompletedScreen" },
  { label: "Charging History", value: "ChargingHistoryScreen" },
  { label: "Charging Price", value: "ChargingPriceScreen" },
  { label: "Charging StartUp", value: "ChargingStartUpScreen" },
  { label: "Charging Status", value: "ChargingStatusScreen" },
  { label: "Coupon", value: "CouponScreen" },
  { label: "Enter Email", value: "EnterEmailScreen" },
  { label: "Enter Name", value: "EnterNameScreen" },
  { label: "Google Login", value: "GoogleLoginScreen" },
  { label: "Home", value: "HomeScreen" },
  { label: "Intro", value: "IntroScreen" },
  { label: "Launch", value: "LaunchScreen" },
  { label: "Login", value: "LoginScreen" },
  { label: "My Credit Card", value: "MyCreditCardScreen" },
  { label: "Notification", value: "NotificationScreen" },
  { label: "Order Details", value: "OrderDetailsScreen" },
  { label: "Order History", value: "OrderHistoryScreen" },
  { label: "Order Summary", value: "OrderSummaryScreen" },
  { label: "Overtime Fee", value: "OvertimeFeeScreen" },
  { label: "Overtime Payment Success", value: "OvertimePaymentSuccessScreen" },
  { label: "Payment Selection", value: "PaymentSelectionScreen" },
  { label: "Penalty CountDown", value: "PenaltyCountDownScreen" },
  { label: "Pin Address", value: "PinAddressScreen" },
  { label: "PDPA", value: "PdpaScreen" },
  { label: "Profile", value: "ProfileScreen" },
  { label: "QR Scanner", value: "QRScannerScreen" },
  { label: "Request Charger", value: "RequestChargerScreen" },
  { label: "RFID Registartion", value: "RFIDRegistartionScreen" },
  { label: "Select Vehicle", value: "SelectVehicleScreen" },
  { label: "Shop", value: "ShopScreen" },
  { label: "Shop Address", value: "ShopAddressScreen" },
  { label: "Side Menu", value: "SideMenuScreen" },
  { label: "Station & Connectors", value: "StationAndConnectorsScreen" },
  { label: "Station List", value: "StationListScreen" },
  { label: "Wallet", value: "WalletScreen" },
]);